var map = {
	"./ag-active.webp": "Moqq",
	"./bb-active.webp": "RfZf",
	"./ob-active.webp": "aHd4",
	"./og-active.webp": "3aJy"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "DEUq";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/video ^\.\/.*\-active\.webp$
// module id = DEUq
// module chunks = 3